import { render } from "./notify.vue?vue&type=template&id=08f09f5b&scoped=true"
import script from "./notify.vue?vue&type=script&lang=js"
export * from "./notify.vue?vue&type=script&lang=js"

import "./notify.vue?vue&type=style&index=0&id=08f09f5b&lang=scss&scoped=true"

import exportComponent from "F:\\我的文件夹\\项目\\xzfp-fp\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f09f5b"]])

export default __exports__